import "./footer.scss";
import instaIcon from "../../assets/images/icons/insta-green.svg";
import telIcon from "../../assets/images/icons/telegram-green.svg";
import locationIcon from "../../assets/images/icons/location-green.svg";
import whiteInstaIcon from "../../assets/images/icons/insta.svg";
import whiteTelIcon from "../../assets/images/icons/telegram.svg";
import whiteLocationIcon from "../../assets/images/icons/location.svg";
import bazaar from "../../assets/icons/bazaar.png";
import ios from "../../assets/icons/ios.png";

const Footer = ({ configs }) => {
  const { REACT_APP_URL } = process.env;

  const pwaInstallation = async () => {
    await fetch(`${REACT_APP_URL}/api/pwa`, { method: "POST" });
  };

  return (
    <div className="footer" id="footer-sec">
      <div className="footer-container">
        <div className="info footer-item">
          <div className="info-item">
            آدرس:{" "}
            <a href="https://maps.app.goo.gl/d3fPk9QEK5WXFyYLA">
              {configs?.address}
            </a>
          </div>
          <div className="info-item">
            تلفن:
            <span className="ltr">
              <a href={`tel:${configs?.phone}`}> &#x200E;{configs?.phone}</a>
            </span>
          </div>
          <div className="info-item en">
            ایمیل: <a href={`mailto:${configs?.email}`}>{configs?.email}</a>
          </div>
        </div>
        <div className="max-[1000px]:w-[90%] flex justify-between items-center flex-row-reverse max-[650px]:flex-col">
        <div className="footer-social">
          <a href={`https://instagram.com/${configs?.instagram}`}>
            <img alt="social" src={whiteInstaIcon} />
          </a>
          <a href={`https://t.me/${configs?.telegram}`}>
            <img alt="social" src={whiteTelIcon} />
          </a>
          <a href="https://maps.app.goo.gl/d3fPk9QEK5WXFyYLA">
            <img alt="social" src={whiteLocationIcon} />
          </a>
        </div>

        <div className="i-app footer-item">
          <div className="i-app-desc">:نصب اپلیکیشن</div>
          <div className="download-app">
            <a href="https://cafebazaar.ir/app/org.mojtahedi.app">
              <img src={bazaar} alt="bazaar download" />
            </a>
            <a href="https://pwa.mojtahedi.org/" onClick={pwaInstallation}>
              <img src={ios} alt="ios download" />
            </a>
          </div>
        </div>
        </div>
      </div>
      <div className="mini-footer">
        <div className="mini-item">
          طراحی شده توسط گروه <a href="https://telmis.ir/">تلمیس</a>
        </div>
      </div>
    </div>
  );
};
export default Footer;
